import { Injectable } from '@angular/core';

import { AuthGuardService } from '@shared/services';

@Injectable()
export class StoreOperationPermission {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasManageResetExpiredPromotionTag(): boolean {
    return this.authGuardService.checkPermission(['reset_exp_pro_tag_m']);
  }

  public get hasViewResetExpiredPromotionTag(): boolean {
    return this.authGuardService.checkPermission(['reset_exp_pro_tag_v']);
  }

  public get hasManageFocusSalesProduct(): boolean {
    return this.authGuardService.checkPermission(['focus_prod_m']);
  }

  public get hasViewFocusSalesProduct(): boolean {
    return this.authGuardService.checkPermission(['focus_prod_v']);
  }
}
